import { gql } from 'types/__generated__/gql';

const KEY_EXPORT_USER_REPORT_QUERY = gql(/* GraphQL */ `
  query getUserReportExporting($id: Int!, $dateRange: DateRangeInput!) {
    user(where: { id: $id }) {
      id
      firstName
      lastName
      sisId
    }
    classrooms: keyOrganizationClassroomEngagementReportAsync(
      where: { userId: $id }
      dateRange: $dateRange
    ) {
      id
      error
      result {
        ...BaseKeyboardingClassroomExport
      }
    }
    students: keyClassroomEngagementReportAsync(where: { userId: $id }, dateRange: $dateRange) {
      id
      error
      result {
        ...BaseKeyboardingStudentExport
      }
    }
  }
`);

export default KEY_EXPORT_USER_REPORT_QUERY;
